import React, { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { InputAdornment, TextField, Button, TableContainer, Table, TableHead, TableBody, Paper, TablePagination } from '@mui/material';
import {StyledTableCell, StyledTableRow} from './tabs_style'
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

// CSS para los botones de acción
const actionButtonsCSS = `
    .action-buttons {
        display: flex;
        gap: 20px;
    }

    .action-buttons a:hover {
        opacity: 0.7; //Cambia la opacidad al pasar el cursor 
        cursor: pointer;  Cambia el cursor al pasar sobre los botones 
    }
`;

function ListaSeparaciones() {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const rows = [
        { id: 1, codigo: '12345', expediente: '54321', nombre: 'Juan Miguel Pérez Sabillón', fecha: '2024-05-10' },
        { id: 2, codigo: '23456', expediente: '65432', nombre: 'María Magdalena García Rosa', fecha: '2024-05-09' },
        { id: 3, codigo: '34567', expediente: '76543', nombre: 'Carlos Eduardo Rodríguez Murillo', fecha: '2024-05-08' },
        { id: 4, codigo: '45678', expediente: '87654', nombre: 'Ana María López Castellanos', fecha: '2024-05-07' },
        { id: 5, codigo: '56789', expediente: '98765', nombre: 'Luis José Martínez Calderón', fecha: '2024-05-06' },
        { id: 6, codigo: '12345', expediente: '54321', nombre: 'Carlos Francisco Alvarado Sabillón', fecha: '2024-05-10' },
        { id: 7, codigo: '23456', expediente: '65432', nombre: 'Fernando Roberto Montes Ávila', fecha: '2024-05-09' },
        { id: 8, codigo: '34567', expediente: '76543', nombre: 'María Fernanda Pineda Escoto', fecha: '2024-05-08' },
        { id: 9, codigo: '45678', expediente: '87654', nombre: 'Dirian Daniela Martinez Fiallos', fecha: '2024-05-07' },
        { id: 10, codigo: '56789', expediente: '98765', nombre: 'Jorge Daniel Pérez Ferrera', fecha: '2024-05-06' },
        { id: 11, codigo: '12345', expediente: '54321', nombre: 'Juan Miguel Pérez Durón', fecha: '2024-05-10' },
        { id: 12, codigo: '23456', expediente: '65432', nombre: 'María Aurora García Paz', fecha: '2024-05-09' },
        { id: 13, codigo: '34567', expediente: '76543', nombre: 'Carlos Nahun Rodríguez Avelar', fecha: '2024-05-08' },
        { id: 14, codigo: '45678', expediente: '87654', nombre: 'Ana Guadalupe López Muñoz', fecha: '2024-05-07' },
        { id: 15, codigo: '56789', expediente: '98765', nombre: 'Héctor José Martínez Enamorado', fecha: '2024-05-06' },
    ];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <div className="container">
            <style>{actionButtonsCSS}</style>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <h2><b>Separación Del Sistema</b></h2>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <TextField
                    className="form-control mr-sm-2"
                    label="Búsqueda"
                    placeholder="Realizar Búsqueda"
                    aria-label="Search"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                />

                <Button variant="contained" startIcon={<PlaylistAddIcon />} style={{backgroundColor: "#AD8401"}}>
                    Agregar
                </Button>
            </div>
            <div className="row" style={{ marginTop: '20px' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center' }}>#</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}><strong>Código</strong></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}><strong>Expediente</strong></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}><strong>Nombre</strong></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}><strong>Fecha</strong></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}><strong>Acciones</strong></StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {(rowsPerPage > 0
                                ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                : rows
                            ).map((row) => (
                                <StyledTableRow key={row.id}>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{row.id}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{row.codigo}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{row.expediente}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{row.nombre}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{row.fecha}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                        <div className="action-buttons" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <a href="#" className="view" title="Ver" style={{ color: '#10ab80', margin: '0 1px' }}>
                                                <i className="material-icons">&#xE417;</i>
                                            </a>
                                            <a href="#" className="edit" title="Editar" style={{ color: 'orange', margin: '0 1px' }}>
                                                <i className="material-icons">&#xE254;</i>
                                            </a>
                                            <a href="#" className="delete" title="Eliminar" style={{ color: 'red', margin: '0 1px' }}>
                                                <i className="material-icons">&#xE872;</i>
                                            </a>
                                        </div>
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </div>
    );
}

export default ListaSeparaciones;